export enum ReportTypeTermsEnum {
  Impact = 'Impact',
  Achievement = 'Achievement',
  Student = 'Student',
  Gradebook = 'Student',
}
